<template>
  <v-container style="margin-top: -10px" class="pt-0" fluid fill-height>
    <v-dialog v-model="modal" scrollable width="100%">
      <InvoiceTable
        v-if="modal"
        @generated="onPaymentGeneration"
        @onClose="close"
        :statusFilter="statusFilter"
        :productFilter="productFilter"
        :productTypes="productTypes"
        :costCenters="costCenters"
      />
  </v-dialog>
  <v-dialog persistent v-model="referenceModal" scrollable :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '100%' : '55%'">
    <PaymentReference
      :key="paymentReferenceKey"
      @onClose="close"
      :paymentReference="paymentReference"
      :referenceId="referenceId"
    />
  </v-dialog>
    <v-flex xs12 class="text-center mb-0 pb-0">
      <v-row class="mb-0 pb-0">
        <v-col cols="6" class="text-right" v-show="$store.getters.isAuthBI">
          <v-btn
            @click="activateProduct(productTypes.BI.productId)"
            aspect-ratio="16/9"
            :width="productBIactivated ? '100%': '95%'"
            :height="productBIactivated ? '128%': '100%'"
            color="#5C9DF2"
            class="btn-round"
          >
            <!-- :disabled="!$store.getters.isAuthBI" -->
          <span
            class="font-weight-black white--text"
            :class="{
              'text-h6': productBIactivated,
              'subtitle-1': productBIactivated,
              'subtitle-2': !productBIactivated,
            }"
          >
              <!-- 'white--text': $store.getters.isAuthBI,
              'info--text': !$store.getters.isAuthBI, -->
            Blú<br>Index
          </span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-left" v-show="$store.getters.isAuthFB">
          <v-btn
            @click="activateProduct(productTypes.FB.productId)"
            aspect-ratio="16/9"
            :width="productFBactivated ? '100%': '95%'"
            :height="productFBactivated ? '128%': '100%'"
            :large="productFBactivated"
            color="#5C9DF2"
            class="btn-round"
            :class="{ 'px-5': $vuetify.breakpoint.mdAndDown }"
          >
            <!-- :disabled="!$store.getters.isAuthFB" -->
            <span
              class="font-weight-black white--text"
              :class="{
                'text-h6': productFBactivated,
                'subtitle-1': productFBactivated,
                'subtitle-2': !productFBactivated,
              }"
            >
                <!-- 'white--text': $store.getters.isAuthFB,
                'info--text': !$store.getters.isAuthFB, -->
              Factoraje<br>American
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-flex>
    <v-flex class="text-center">
      <h2 class="mt-7 accent--text" v-if="!hasChartData">No tienes facturas</h2>
      <VueApexCharts ref="grafico" type="donut" :options="chartOptions" :series="dataForChart" class="chart-x"/>
    </v-flex>
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Status from '@/common/FactoringDocumentStatus.js'
import InvoiceTable from '@/components/InvoiceTable'
import PaymentReference from '@/components/PaymentReference'
import FactoringDocumentService from '@/services/FactoringDocumentService'
import StpService from '@/services/StpService'

export default {
  name: 'GraficoFactoraje',
  props: {
    productTypes: {
      type: Object,
      required: true
    },
    invoices: {
      type: Array,
      required: true
    }
  },
  components: {
    InvoiceTable,
    PaymentReference,
    VueApexCharts
  },
  data () {
    return {
      chartOptions: {
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '50%'
            }
          }
        },
        fill: {
          opacity: 1
        },
        chart: {
          animations: { enabled: false },
          selection: { enabled: false },
          fill: {
            opacity: 1
          },
          type: 'donut',
          events: {
            dataPointSelection: this.handleChartSelect
          }
        },
        colors: ['#0420BF', '#5C9DF2', '#1374F2'],
        pieHole: 0.4,
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px'
        }
      },
      dataForChart: [],
      statusIndex: {},
      statusFilter: Status.CREDITO,
      productFilter: null,
      productFBactivated: false,
      productBIactivated: false,
      modal: false,
      referenceModal: false,
      paymentReference: null,
      paymentReferenceKey: 0,
      referenceId: null,
      costCenters: [],
      isButtonEnabled: { BI: true, FB: true }
    }
  },
  methods: {
    // Se llama desde el dashboard
    setInitialProduct () {
      if (this.$store.getters.isAuthBI) {
        this.productBIactivated = true
      } else if (this.$store.getters.isAuthFB) {
        this.productFBactivated = true
      }
    },

    async activateProduct (productId) {
      let productsActive
      if (productId === this.productTypes.BI.productId) {
        this.productBIactivated = true
        this.productFBactivated = false
        productsActive = {
          productBI: this.productBIactivated,
          productFB: this.productFBactivated
        }
      }
      if (productId === this.productTypes.FB.productId) {
        this.productFBactivated = true
        this.productBIactivated = false
        productsActive = {
          productBI: this.productBIactivated,
          productFB: this.productFBactivated
        }
      }
      this.setProductFilter()
      await this.getInvoices(productId)
      this.setChartData(this.invoices)
      this.$emit('product-selected', productsActive)
    },

    close () {
      this.referenceModal = false
      this.modal = false
    },

    onPaymentGeneration (reference) {
      this.modal = false
      this.paymentReference = reference.paymentReference
      this.referenceId = reference.referenceId
      this.paymentReferenceKey += 1
      this.referenceModal = true
    },

    async getInvoices (productId = null) {
      let products = [productId]
      if (!productId) {
        products = [this.productTypes.BI.productId, this.productTypes.FB.productId]
      }

      try {
        const { data } = await FactoringDocumentService.getDocuments({
          clientId: this.$store.getters.user.clientId,
          products,
          status: [
            Status.RECHAZADA,
            Status.PREVENTA,
            Status.CREDITO
          ],
          sevenDaysRejectedDate: true
        })

        const rejected = data.filter(item => item.status === Status.RECHAZADA)
        await this.$store.dispatch('updateInvoicesByStatus', {
          invoices: rejected,
          status: Status.RECHAZADA
        })

        const presell = data.filter(item => item.status === Status.PREVENTA)
        await this.$store.dispatch('updateInvoicesByStatus', {
          invoices: presell,
          status: Status.PREVENTA
        })

        const credit = data.filter(item => item.status === Status.CREDITO)
        await this.$store.dispatch('updateInvoicesByStatus', {
          invoices: credit,
          status: Status.CREDITO
        })
      } catch (error) {
        console.error(error)
      }
    },
    async handleChartSelect (event, chartContext, config) {
      const loader = this.$loading.show()
      this.setProductFilter()
      const selected = config.dataPointIndex
      switch (selected) {
      case this.statusIndex.CREDITO:
        this.statusFilter = Status.CREDITO
        try {
          const { data } = await FactoringDocumentService.getDocuments({
            clientId: this.$store.getters.user.clientId,
            products: [this.productFilter],
            status: [Status.CREDITO],
            withoutPaymentDate: true
          })
          await this.$store.dispatch('updateCreditInvoices', data)
        } catch (error) {
          console.info(error)
        }
        try {
          const data = await StpService.getPayerCostCenterByClient(this.$store.getters.user.client.rfc || '')
          this.costCenters = data
        } catch (error) {
          this.costCenters = []
          console.error(error)
        }
        break
      case this.statusIndex.RECHAZADA:
        this.statusFilter = Status.RECHAZADA
        break
      case this.statusIndex.PREVENTA:
        this.statusFilter = Status.PREVENTA
        break
      default:
        this.statusFilter = Status.CREDITO
        break
      }
      await this.getInvoices()
      this.modal = true
      loader.hide()
    },
    setProductFilter () {
      if (this.productFBactivated) {
        this.productFilter = this.productTypes.FB.productId
      }
      if (this.productBIactivated) {
        this.productFilter = this.productTypes.BI.productId
      }
    },
    setLabels (labels) {
      this.statusIndex = Object.assign({})
      this.$set(this.chartOptions, 'labels', [])
      for (const label of labels) {
        this.$set(this.statusIndex, label.prop, label.index)
      }
      this.$set(this.chartOptions, 'labels', labels.map(item => item.label))
    },
    setChartData (invoices) {
      this.dataForChart = []
      const data = []
      const labels = []

      if (invoices && invoices.length > 0) {
        let baseInvoices = [...invoices]

        if ((this.productBIactivated || this.productFBactivated) && this.productTypes) {
          this.setProductFilter()
          baseInvoices = baseInvoices.filter(invoice => invoice.productId === this.productFilter)
        }

        const credito = baseInvoices.filter(invoice => invoice.status === Status.CREDITO)
        const rechazadas = baseInvoices.filter(invoice => invoice.status === Status.RECHAZADA)
        const validacion = baseInvoices.filter(invoice => invoice.status === Status.PREVENTA)

        data.push(credito.length)
        labels.push({ label: 'En crédito', prop: 'CREDITO', index: (data.length - 1) })

        data.push(rechazadas.length)
        labels.push({ label: 'Rechazadas', prop: 'RECHAZADA', index: (data.length - 1) })

        data.push(validacion.length)
        labels.push({ label: 'En validación', prop: 'PREVENTA', index: (data.length - 1) })

        this.setLabels(labels)
      }
      this.dataForChart = data.map(item => item)
    }
  },
  computed: {
    hasChartData () {
      return this.dataForChart.some(value => value > 0)
    }
  },
  watch: {
    invoices: function (newVal, oldVal) {
      this.setChartData(newVal)
    },
    '$store.getters.isAuthBI': function () {
      this.setInitialProduct()
      this.setChartData(this.invoices)
    },
    '$store.getters.isAuthFB': function () {
      this.setInitialProduct()
      this.setChartData(this.invoices)
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart-x {
    height: 45vh;
    padding: 0 0;
  }
  .btn-round {
    border-radius: 15px;
  }
  [class$="--disabled"],
  [class*="--disabled "] * {
      color: #1374F2 !important;
  }
</style>
